"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ConfirmOverlay_1 = __importDefault(require("../../components/posa/ConfirmOverlay"));
const CtaSection_1 = __importDefault(require("../../components/posa/CtaSection"));
const FaqSection_1 = __importDefault(require("../../components/posa/FaqSection"));
const MetaTags_1 = __importDefault(require("../../components/MetaTags"));
const PosaCardRedeemViewStyled_1 = __importDefault(require("./PosaCardRedeemViewStyled"));
const PosaCardSuccessView_1 = __importDefault(require("./PosaCardSuccessView"));
const PosaMessageContext_1 = require("../../context/PosaMessageContext");
const PosaRedeemActions_1 = __importDefault(require("../../actions/PosaRedeemActions"));
const PosaRedeemStore_1 = __importDefault(require("../../stores/PosaRedeemStore"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const RedeemSection_1 = __importDefault(require("../../components/posa/RedeemSection"));
const react_router_1 = require("react-router");
const RichText_1 = __importDefault(require("../../components/posa/RichText"));
const epic_alt_utils_1 = require("epic-alt-utils");
const classnames_1 = __importDefault(require("classnames"));
const epic_tracking_1 = __importDefault(require("epic-tracking"));
const query_string_1 = __importDefault(require("query-string"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const route_1 = require("../../utils/route");
/**
 * POSA Card Redeem View.
 */
let PosaCardRedeemView = class PosaCardRedeemView extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            landingPageViewed: false
        };
        // we always show unloggedIn section until use clicked "Get Started" button
        this.setViewed = () => {
            epic_tracking_1.default.trackEvent('Interaction', {
                interactionType: 'click',
                eventCategory: 'PosaRedeem',
                eventAction: 'getstarted'
            });
            this.setState({
                landingPageViewed: true
            });
        };
        this.getStartAction = warningContent => {
            const { loginAction, isLoggedIn } = this.props;
            if (!isLoggedIn) {
                loginAction(warningContent);
            }
            else {
                this.setViewed();
            }
        };
        this.getMetaTags = () => {
            const { page: { metaTags } } = this.props.posaRedeemStore;
            return react_1.default.createElement(MetaTags_1.default, { meta: metaTags });
        };
        this.renderLoading = () => {
            const loading = this.props.loadScreen || react_1.default.createElement("div", { className: "loading" });
            return loading;
        };
        this.render404 = () => {
            const { notFoundRedirect } = this.props;
            return notFoundRedirect || react_1.default.createElement(react_router_1.Redirect, { to: route_1.generateRouteTo('page-not-found', this.props.location) });
        };
        this.resetFlow = () => {
            window_or_global_1.default.scrollTo(0, 0);
            PosaRedeemActions_1.default.resetFlow();
        };
        this.renderSuccessView = () => {
            const { ctaAction } = this.props;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                this.getMetaTags(),
                react_1.default.createElement(PosaCardSuccessView_1.default, { ctaAction: ctaAction, resetFlow: this.resetFlow, trackEvent: PosaRedeemActions_1.default.track })));
        };
        this.renderMainPage = () => {
            const { page: { messages, sections: { sections }, configs: { id }, loginModal }, codeVerified } = this.props.posaRedeemStore;
            const { location } = this.props;
            const code = location.search ? query_string_1.default.parse(location.search).code || '' : '';
            const { landingPageViewed } = this.state;
            const { ctaAction, isLoggedIn, accountName, uppercaseCode } = this.props;
            const list = sections.map(section => {
                let jsx = null;
                for (const prop in section) {
                    if (section.hasOwnProperty(prop)) {
                        const data = section[prop];
                        if (typeof data === 'object') {
                            const { _type } = data;
                            switch (_type) {
                                case 'POSA Redeem Section':
                                    jsx = (react_1.default.createElement(RedeemSection_1.default, { landingPageViewed: landingPageViewed, data: data, prefilledCode: code, accountName: accountName, uppercaseCode: uppercaseCode, key: _type, isLoggedIn: isLoggedIn, getStartAction: this.getStartAction, loginModal: loginModal, posaRedeemStore: this.props.posaRedeemStore }));
                                    break;
                                case 'POSA FAQ Section':
                                    jsx = react_1.default.createElement(FaqSection_1.default, { data: data, key: _type });
                                    break;
                                case 'POSA CTA Section':
                                    jsx = react_1.default.createElement(CtaSection_1.default, { data: data, key: _type, ctaAction: ctaAction });
                                    break;
                                case 'POSA Rich Text':
                                    jsx = react_1.default.createElement(RichText_1.default, { data: data, key: _type });
                                    break;
                                default:
                                // no-op
                            }
                        }
                    }
                }
                return jsx;
            });
            const classNames = classnames_1.default(`epic-code-redemption posaRedeemView ${isLoggedIn ? 'loggedIn' : 'unloggedIn'}`, {
                codeVerified,
                landingPageViewed
            });
            const close = () => PosaRedeemActions_1.default.setShowConfirm(false);
            const redeemFunc = () => {
                window_or_global_1.default.scrollTo(0, 0);
                PosaRedeemActions_1.default.redeemCode();
            };
            return (react_1.default.createElement(PosaMessageContext_1.PosaMessageProvider, { value: JSON.parse(messages) },
                this.getMetaTags(),
                react_1.default.createElement(PosaCardRedeemViewStyled_1.default, { className: classNames, id: id },
                    list,
                    react_1.default.createElement(ConfirmOverlay_1.default, { posaRedeemStore: this.props.posaRedeemStore, close: close, redeemFunc: redeemFunc, resetFlow: this.resetFlow }))));
        };
        let landingPageViewed = false;
        try {
            const qs = query_string_1.default.parse(props.location.search);
            if (qs.fromCta) {
                landingPageViewed = true;
            }
            if (qs.code) {
                landingPageViewed = true;
            }
        }
        catch (ex) {
            // no-op
        }
        this.state = {
            landingPageViewed
        };
    }
    static getStores() {
        return [PosaRedeemStore_1.default];
    }
    static getPropsFromStores() {
        return {
            posaRedeemStore: PosaRedeemStore_1.default.getState()
        };
    }
    static getInitialActions() {
        return [
            props => {
                const { page } = props.posaRedeemStore;
                if (!page) {
                    PosaRedeemActions_1.default.getCmsContent();
                }
            }
        ];
    }
    render() {
        const { loading, page, redeemed } = this.props.posaRedeemStore;
        if (loading)
            return this.renderLoading();
        try {
            if (!page || !page.configs.enablePOSA)
                return this.render404();
        }
        catch (ex) {
            return this.render404();
        }
        if (redeemed)
            return this.renderSuccessView();
        return this.renderMainPage();
    }
};
PosaCardRedeemView.propTypes = {
    posaRedeemStore: prop_types_1.default.object,
    location: prop_types_1.default.object,
    redeemStore: prop_types_1.default.object,
    loadScreen: prop_types_1.default.node,
    notFoundRedirect: prop_types_1.default.node,
    uppercaseCode: prop_types_1.default.bool,
    loginAction: prop_types_1.default.func,
    ctaAction: prop_types_1.default.func,
    isLoggedIn: prop_types_1.default.bool,
    accountName: prop_types_1.default.string
};
PosaCardRedeemView = __decorate([
    epic_alt_utils_1.connectToStores,
    __metadata("design:paramtypes", [Object])
], PosaCardRedeemView);
exports.default = react_router_1.withRouter(PosaCardRedeemView);
//# sourceMappingURL=PosaCardRedeemView.js.map